import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import 'prop-types';
import { jsx } from '@emotion/core';
import { dlsWhiteBg } from '../../styles/colorsDls/dlsWhiteBg.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ModalBody = function ModalBody(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["theme", "children"]);

  return jsx("div", _extends({
    css: _objectSpread(_objectSpread({}, dlsWhiteBg), theme)
  }, otherProps), children);
};

ModalBody.defaultProps = {
  theme: undefined
};

export default ModalBody;
